window.addEventListener("load", () => {
  let lastScrollHash = null;
  let heightObserverTimeout = null;

  function smoothScrollToHash(hash) {
    const targetId = hash.substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const isMobile = window.innerWidth <= 768;
      const offset = isMobile ? 80 : 90;
      const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth",
      });

      // After scrolling, check if page height changes, then rerun scroll
      observePageHeightChange(hash);
    }
  }

  function observePageHeightChange(hash) {
    let initialHeight = document.body.scrollHeight;
    let attempts = 0;
    let maxAttempts = 10; // maximum time ~1s

    function checkHeight() {
      let currentHeight = document.body.scrollHeight;
      if (currentHeight !== initialHeight) {
        // Try to scroll again
        smoothScrollToHash(hash);
      } else if (attempts < maxAttempts) {
        attempts++;
        heightObserverTimeout = setTimeout(checkHeight, 100);
      }
    }

    // Prevent multiple observer runs
    if (heightObserverTimeout) clearTimeout(heightObserverTimeout);

    setTimeout(checkHeight, 100);
  }

  if (window.location.hash) {
    lastScrollHash = window.location.hash;
    smoothScrollToHash(window.location.hash);
  }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", event => {
      const href = anchor.getAttribute("href");
      if (href.length > 1) {
        event.preventDefault();
        history.pushState(null, null, href);
        lastScrollHash = href;
        smoothScrollToHash(href);
      }
    });
  });
});
